import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { Redirect } from 'graphql.generated';
import { REDIRECT_QUERY } from 'queries/search/redirects';

type RedirectQuery = {
    redirects: Redirect[];
};

export const fetchListingRedirect = async (
    apolloClient: ApolloClient<NormalizedCacheObject>,
    listingPath: string
) => {
    try {
        const redirects = await apolloClient.query<RedirectQuery>({
            query: REDIRECT_QUERY,
            variables: {
                path: listingPath
            }
        });

        const redirect = redirects?.data.redirects[0];

        if (!redirect) {
            return {
                uri: '/',
                code: 301
            };
        }

        const { redirectUri, code } = redirect;

        return {
            uri: redirectUri || '/',
            code: parseInt(code || '301', 10)
        };
    } catch (exception) {
        return null;
    }
};

export default fetchListingRedirect;
